export enum InputCategory {
    General = 'general',
    Camera = 'camera',
    Poi = 'poi',
    Article = 'article',
    Selection = 'selection',
    Placement = 'placement'
}
